// Per-route SEO metadata (FR/EN). Titles ~55-60 chars, descriptions ~150-160 chars.
export const SITE_NAME = "Domaine de la Bégaudière";
export const SITE_URL = "https://labegaudiere.fr";
export const DEFAULT_OG_IMAGE =
  SITE_URL + "/api/files/begaudiere/uploads/d6f04c4d-330b-4b70-9572-3efe0c0b7961.jpg";

export const BUSINESS = {
  name: SITE_NAME,
  street: "12 La Bégaudière",
  postalCode: "35120",
  city: "Mont-Dol",
  region: "Bretagne",
  country: "FR",
  phone: "+33255997016",
  email: "contact@labegaudiere.fr",
  latitude: 48.55415,
  longitude: -1.76457,
};

export const SEO = {
  "/": {
    fr: {
      title: "Domaine de la Bégaudière · Gîtes & chambres d'hôtes, Mont-Saint-Michel",
      description:
        "Gîtes et chambres d'hôtes de charme au cœur de la baie du Mont-Saint-Michel, à Mont-Dol près de Dol-de-Bretagne, Saint-Malo et Cancale. Réservez en direct.",
    },
    en: {
      title: "Domaine de la Bégaudière · Cottages & B&B near Mont-Saint-Michel",
      description:
        "Charming cottages and bed & breakfast in the Bay of Mont-Saint-Michel, at Mont-Dol near Dol-de-Bretagne, Saint-Malo and Cancale. Book direct.",
    },
  },
  "/chambres-hotes": {
    fr: {
      title: "Chambres d'hôtes à Mont-Dol, près du Mont-Saint-Michel | La Bégaudière",
      description:
        "Chambres d'hôtes de charme à Mont-Dol (35120) avec petit-déjeuner, près du Mont-Saint-Michel, Dol-de-Bretagne et Saint-Malo. Confort, calme et authenticité.",
    },
    en: {
      title: "Bed & Breakfast in Mont-Dol, near Mont-Saint-Michel | La Bégaudière",
      description:
        "Charming B&B rooms in Mont-Dol with breakfast, near Mont-Saint-Michel, Dol-de-Bretagne and Saint-Malo. Comfort, peace and authenticity.",
    },
  },
  "/gites": {
    fr: {
      title: "Gîtes à Mont-Dol, près du Mont-Saint-Michel | La Bégaudière",
      description:
        "Location de gîtes tout confort à Mont-Dol, au cœur de la baie du Mont-Saint-Michel. Idéal familles et séjours nature en Bretagne. Réservation en ligne.",
    },
    en: {
      title: "Holiday cottages in Mont-Dol, near Mont-Saint-Michel | La Bégaudière",
      description:
        "Fully-equipped self-catering cottages in Mont-Dol, Bay of Mont-Saint-Michel, Brittany. Perfect for families and nature stays. Book online.",
    },
  },
  "/nos-sejours": {
    fr: {
      title: "Nos séjours & offres · Domaine de la Bégaudière",
      description:
        "Découvrez nos formules et séjours en Bretagne, entre Mont-Saint-Michel et Saint-Malo : escapades romantiques, week-ends nature et offres gourmandes.",
    },
    en: {
      title: "Stays & packages · Domaine de la Bégaudière",
      description:
        "Discover our stays and packages in Brittany, between Mont-Saint-Michel and Saint-Malo: romantic getaways, nature weekends and gourmet offers.",
    },
  },
  "/cheques-cadeaux": {
    fr: {
      title: "Chèques-cadeaux · Domaine de la Bégaudière",
      description:
        "Offrez un séjour au cœur de la baie du Mont-Saint-Michel : chèques-cadeaux valables sur nos gîtes, chambres d'hôtes et séjours en Bretagne.",
    },
    en: {
      title: "Gift cards · Domaine de la Bégaudière",
      description:
        "Give the gift of a stay in the Bay of Mont-Saint-Michel: gift cards valid on our cottages, B&B rooms and stays in Brittany.",
    },
  },
  "/boutique": {
    fr: {
      title: "Boutique · produits bretons du Domaine de la Bégaudière",
      description:
        "Épicerie fine et souvenirs bretons disponibles à l'accueil du domaine : caramels, galettes, cidre, miel et créations locales.",
    },
    en: {
      title: "Shop · Breton products at Domaine de la Bégaudière",
      description:
        "Fine local food and Breton souvenirs available at the estate reception: caramels, biscuits, cider, honey and local crafts.",
    },
  },
  "/seminaires": {
    fr: {
      title: "Séminaires & événements en Bretagne | La Bégaudière",
      description:
        "Organisez votre séminaire d'entreprise près du Mont-Saint-Michel : cadre nature, salles, hébergement et restauration. Demandez votre devis.",
    },
    en: {
      title: "Seminars & events in Brittany | La Bégaudière",
      description:
        "Host your corporate seminar near Mont-Saint-Michel: natural setting, meeting rooms, accommodation and catering. Request your quote.",
    },
  },
  "/le-domaine": {
    fr: {
      title: "Le domaine · histoire & lieu | La Bégaudière",
      description:
        "Découvrez le Domaine de la Bégaudière, ancienne demeure bretonne restaurée au cœur de la baie du Mont-Saint-Michel, à Mont-Dol.",
    },
    en: {
      title: "The estate · history & setting | La Bégaudière",
      description:
        "Discover Domaine de la Bégaudière, a restored Breton estate in the heart of the Bay of Mont-Saint-Michel, at Mont-Dol.",
    },
  },
  "/la-region": {
    fr: {
      title: "Que faire autour du Mont-Saint-Michel & Saint-Malo | La Bégaudière",
      description:
        "Guide de la région : Mont-Saint-Michel, Saint-Malo, Cancale, Dinan, Dol-de-Bretagne. Idées de visites et activités depuis le domaine.",
    },
    en: {
      title: "Things to do around Mont-Saint-Michel & Saint-Malo | La Bégaudière",
      description:
        "Regional guide: Mont-Saint-Michel, Saint-Malo, Cancale, Dinan, Dol-de-Bretagne. Ideas for visits and activities from the estate.",
    },
  },
  "/informations-pratiques": {
    fr: {
      title: "Informations pratiques · accès & séjour | La Bégaudière",
      description:
        "Toutes les infos pratiques pour votre séjour à la Bégaudière : accès, horaires d'arrivée, équipements et services près du Mont-Saint-Michel.",
    },
    en: {
      title: "Practical information · access & stay | La Bégaudière",
      description:
        "All practical info for your stay at La Bégaudière: access, check-in times, facilities and services near Mont-Saint-Michel.",
    },
  },
  "/contact": {
    fr: {
      title: "Contact · Domaine de la Bégaudière, Mont-Dol",
      description:
        "Contactez le Domaine de la Bégaudière à Mont-Dol (35120), près de Dol-de-Bretagne et du Mont-Saint-Michel. Téléphone, e-mail et formulaire.",
    },
    en: {
      title: "Contact · Domaine de la Bégaudière, Mont-Dol",
      description:
        "Contact Domaine de la Bégaudière in Mont-Dol (35120), near Dol-de-Bretagne and Mont-Saint-Michel. Phone, e-mail and form.",
    },
  },
  "/disponibilites": {
    fr: {
      title: "Disponibilités & réservation en ligne | La Bégaudière",
      description:
        "Vérifiez les disponibilités et réservez en direct votre gîte ou chambre d'hôtes au Domaine de la Bégaudière, près du Mont-Saint-Michel.",
    },
    en: {
      title: "Availability & online booking | La Bégaudière",
      description:
        "Check availability and book your cottage or B&B room directly at Domaine de la Bégaudière, near Mont-Saint-Michel.",
    },
  },
  "/mentions-legales": {
    fr: { title: "Mentions légales | La Bégaudière", description: "Mentions légales du Domaine de la Bégaudière." },
    en: { title: "Legal notice | La Bégaudière", description: "Legal notice of Domaine de la Bégaudière." },
  },
  "/confidentialite": {
    fr: { title: "Politique de confidentialité | La Bégaudière", description: "Politique de confidentialité et données personnelles (RGPD)." },
    en: { title: "Privacy policy | La Bégaudière", description: "Privacy policy and personal data (GDPR)." },
  },
  "/cgv": {
    fr: { title: "Conditions générales de vente | La Bégaudière", description: "Conditions générales de vente et de réservation." },
    en: { title: "Terms & conditions | La Bégaudière", description: "General terms of sale and booking." },
  },
  "/annulation": {
    fr: { title: "Conditions d'annulation | La Bégaudière", description: "Conditions d'annulation des réservations." },
    en: { title: "Cancellation policy | La Bégaudière", description: "Booking cancellation conditions." },
  },
};
